import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// 🔹 Smooth slide-up animation
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmDialog({
  open = false,
  title = "Confirmation",
  message = "Are you sure you want to continue?",
  onConfirm = () => {},
  onCancel = () => {},
  confirmText = "Yes",
  cancelText = "No",
  color = "primary", // success | error | info | primary | warning
  icon = <CheckCircleOutlineIcon sx={{ color: "#1976d2", fontSize: 40 }} />,
}) {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: 10,
          background: "linear-gradient(to bottom, #ffffff, #f9fafb)",
          minWidth: 420,
        },
      }}
    >
      {/* 🔹 Header */}
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: "1.4rem",
          color: "#1976d2",
          borderBottom: "1px solid #e0e0e0",
          pb: 1,
        }}
      >
        {icon}
        <Typography
          component="span"
          sx={{ ml: 1, verticalAlign: "middle", fontSize: "1.3rem" }}
        >
          {title}
        </Typography>
      </DialogTitle>

      {/* 🔹 Body */}
      <DialogContent sx={{ mt: 2 }}>
        <Typography
          sx={{
            textAlign: "center",
            color: "#444",
            fontSize: "1rem",
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      {/* 🔹 Actions */}
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          borderTop: "1px solid #e0e0e0",
          mt: 2,
          pt: 2,
        }}
      >
        <Button
          onClick={onCancel}
          variant="outlined"
          color="error"
          sx={{
            borderRadius: "25px",
            px: 3,
            textTransform: "uppercase",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#ffeaea" },
          }}
        >
          {cancelText}
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          color={color}
          sx={{
            borderRadius: "25px",
            px: 3,
            textTransform: "uppercase",
            fontWeight: "bold",
            boxShadow: "0px 3px 5px rgba(0,0,0,0.2)",
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
